import { makeAutoObservable } from 'mobx'
import { EnumDropdownItemVariant, type IDropdownItem } from 'shared/ui'
import { IntegrationKey } from 'entities/Integrations'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { type MergeFieldStore } from 'entities/MergeField'

export class RingFirstDropdownStore {
  constructor(readonly entities: IEntitiesStore, initValue?: string) {
    if (initValue) {
      this.setValue(initValue)
    }
    makeAutoObservable(this)
  }
  private _value = 'simultaneous'
  get value() {
    return this._value
  }
  setValue = (value: string) => {
    this._value = value
  }

  get items() {
    const [id, childrenId] = this.value.split('.')
    return items(this.entities.mergeFieldStore).map((item) => {
      const activeChild = item.children?.find((child) => child.id === childrenId)
      return item.id === id
        ? {
            ...item,
            activeValue: activeChild?.label || true,
            children: item.children?.map((child) =>
              child.id === activeChild?.id ? { ...activeChild, activeValue: true } : child
            ),
          }
        : item
    })
  }
  get activeItem() {
    const [id, childrenId] = this.value.split('.')
    const findActiveItem = this.items.find((item) => item.id === id)
    return childrenId
      ? findActiveItem?.children?.find((child) => child.id === childrenId)
      : findActiveItem
  }
}

const items = (mergeFieldStore: MergeFieldStore): IDropdownItem[] => {
  const getHubspotItems = (filterIds: string[]): IDropdownItem[] =>
    Array.from(mergeFieldStore.getMergeFieldsIntegration(IntegrationKey.hubspot)?.values() || [])
      .filter((item) => item.referencedObjectType === 'OWNER' && !filterIds.includes(item.name))
      .map(({ name, label }) => ({
        id: name,
        label: label,
        iconL: 'hubspot',
        variant: EnumDropdownItemVariant.CheckedRight,
      }))

  return [
    {
      id: 'simultaneous',
      label: 'Simultaneously',
      variant: EnumDropdownItemVariant.CheckedRight,
    },
    {
      id: 'round_robin',
      label: 'Round robin',
      variant: EnumDropdownItemVariant.CheckedRight,
    },
    {
      id: 'linear_round_robin',
      label: 'Linear round robin',
      variant: EnumDropdownItemVariant.CheckedRight,
      divider: true,
    },
    {
      id: IntegrationKey.salesmsg,
      label: 'Salesmsg',
      iconL: 'salesmsg',
      iconR: 'chevronRight',
      children: [
        {
          id: 'contact_owner',
          label: 'Contact owner',
          iconL: 'salesmsg',
          variant: EnumDropdownItemVariant.CheckedRight,
        },
        {
          id: 'conversation_assignee',
          label: 'Conversation assignee',
          iconL: 'salesmsg',
          variant: EnumDropdownItemVariant.CheckedRight,
        },
      ],
    },
    {
      id: IntegrationKey.hubspot,
      label: 'HubSpot',
      iconL: 'hubspot',
      iconR: 'chevronRight',
      childrenDropdownProps: {
        withSearch: true,
        leaveDelay: 400,
      },
      children: [
        {
          id: 'contact_owner',
          label: 'Contact owner',
          iconL: 'hubspot',
          variant: EnumDropdownItemVariant.CheckedRight,
        },
        {
          id: 'deal_owner',
          label: 'Deal owner',
          iconL: 'hubspot',
          variant: EnumDropdownItemVariant.CheckedRight,
        },
        ...getHubspotItems(['hubspot_owner_id', 'deal_owner']),
      ],
    },
  ]
}
